exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cfd-thead[data-v-06cdb63c]{display:table-header-group;background-color:#fff;will-change:transform}.cfd-tr[data-v-06cdb63c]{display:table-row}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06cdb63c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/desktop/InstrumentTableHeader.vue
// module id = 145
// module chunks = 0